import { AccountType, AuthResponse } from '../../api'
import { api, registrationApi }      from '../../client'
import {
  convertEducation,
  convertExperiences,
  convertPersonal,
}                                    from '../../components/forms/schemas'
import { bind, genArgConverter }     from '../../utils'
import createAction                  from '../redux-utils/create-action'
import { Reducer }                   from '../types'
import { createRequest }             from './communication.duck'
import { ApplicationState }          from './index'

/* ACTION TYPES */

const NAMESPACE = 'authentication'

export const LOGIN = `[${NAMESPACE}] LOGIN`
export const LOGOUT = `[${NAMESPACE}] LOGOUT`

export interface AuthState {
  type?: AuthResponse['type']
  token?: AuthResponse['token']
}

const initAuth = {}

const auth: Reducer<AuthState> = (
  state = initAuth,
  {
    type,
    payload,
  },
) => {
  switch (type) {
    case LOGIN:
      return payload

    case LOGOUT:
      return {
        token: null,
        role:  null,
      }

    default:
      return state
  }
}

export default auth

/* ACTIONS */

export const handleLogin = (
  params: Pick<AuthState, 'type' | 'token'>,
) => createAction(
  LOGIN,
  params,
  {
    toast: {
      message: 'successfulLogin',
    },
  },
)

export const logout = () =>
  createAction(
    LOGOUT,
    null,
    {
      toast: {
        message: 'logout',
      },
    },
  )

const handleForgotPassword = createAction(
  '[forgot-password] SUCCESS',
  null,
  {
    toast: {
      message: 'forgotPasswordSuccess',
    }
  }
)

const handleResetPasswordSuccess = createAction(
  '[reset-password] SUCCESS',
  null,
  {
    toast: {
      message: 'resetPasswordSuccess',
    }
  }
)

export const loginMentoringRequest = createRequest({
  namespace:      'login',
  request:        bind(api)(api.loginMentoring),
  successHandler: handleLogin,
})

export const forgotPasswordRequest = createRequest({
  namespace:      'forgot-password',
  request:        bind(api)(api.forgotPassword),
  successHandler: handleForgotPassword,
})

export const resetPasswordRequest = createRequest({
  namespace:      'reset-password',
  request:        bind(api)(api.resetPassword),
  successHandler: handleResetPasswordSuccess,
})

const {
  Mentee,
  Mentor,
  Coach,
  Coachee,
  CompanyMentoring,
  CompanyCoaching,
} = AccountType

const accountTypeToRegistration = {
  [ Mentee ]: genArgConverter(values => ({
    ...convertPersonal(values),
    ...convertEducation(values),
    ...convertExperiences(values),
    ...values,
  }))(registrationApi.registerMentee.bind(registrationApi)),

  [ Mentor ]: genArgConverter(values => ({
    ...convertPersonal(values),
    ...convertEducation(values),
    ...convertExperiences(values),
    ...values,
  }))(registrationApi.registerMentor.bind(registrationApi)),

  [ Coachee ]: genArgConverter(values => ({
    ...convertEducation(values),
    ...convertExperiences(values),
    ...convertPersonal(values),
    ...values,
  }))(registrationApi.registerCoachee.bind(registrationApi)),

  [ Coach ]: genArgConverter(values => ({
    ...convertEducation(values),
    ...convertExperiences(values),
    ...convertPersonal(values),
    ...values,
  }))(registrationApi.registerCoach.bind(registrationApi)),

  [ CompanyMentoring ]: registrationApi.registerCompany.bind(registrationApi),

  [ CompanyCoaching ]: registrationApi.registerCompany.bind(registrationApi),
}

export const genRegisterRequest = (accountType: AccountType) =>
  createRequest({
    namespace: `register-${accountType}`,
    request:   accountTypeToRegistration[ accountType ],
  })

/* SELECTORS */

export const selectAuthState = ({ auth }: ApplicationState) => auth

export const selectAccountType = ({ auth: { type } }: ApplicationState) => type



// WEBPACK FOOTER //
// ./src/redux/ducks/authentication.duck.ts